import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations/translations';
import './Projects.css';

const Testimonials = () => {
  const { currentLanguage } = useLanguage();
  const t = translations[currentLanguage];

  const testimonials = [
    {
      text: 'Чуткий и отзывчивый специалист. Даже одна встреча вселяет доверие и надежду.',
      author: 'Tomash',
      image: '💙',
      rating: 5
    },
    {
      text: 'За несколько лет совместной работы я преодолела психосоматические симптомы, укрепила самооценку и наладила отношения с близкими.',
      author: 'Кэсси',
      image: '🌟',
      rating: 5
    },
    {
      text: 'Очень комфортно и безопасно общаться. Помогает принимать важные решения без сомнений.',
      author: 'id688674',
      image: '🤝',
      rating: 5
    },
    {
      text: 'Благодаря консультации увидела ситуацию шире и нашла силы для изменений.',
      author: 'Allegoria',
      image: '✨',
      rating: 5
    }
  ];

  const renderStars = (rating) => {
    return '★'.repeat(rating) + '☆'.repeat(5 - rating);
  };

  return (
    <section id="testimonials" className="projects">
      <div className="container">
        <h2 className="section-title">{t.testimonials.title}</h2>
        <p className="section-subtitle">
          {t.testimonials.subtitle}
        </p>
        
        <div className="testimonials-photo-section">
          <img 
            src="/images/ludmila-photo-3.jpg" 
            alt={`${t.hero.title} в робочій обстановці`}
            className="testimonials-photo"
          />
          <div className="photo-caption">
            <p>
              {currentLanguage === 'uk' ? 'Створюю безпечний простір для ваших змін' : 
               currentLanguage === 'ru' ? 'Создаю безопасное пространство для ваших изменений' :
               currentLanguage === 'cs' ? 'Vytvářím bezpečný prostor pro vaše změny' :
               'Creating a safe space for your changes'}
            </p>
          </div>
        </div>
        
        <div className="projects-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="project-card testimonial-card">
              <div className="project-image">
                <span className="project-emoji">{testimonial.image}</span>
              </div>
              <div className="project-content">
                <div className="testimonial-rating">
                  <span className="stars">{renderStars(testimonial.rating)}</span>
                </div>
                <p className="project-description testimonial-text">"{testimonial.text}"</p>
                <div className="testimonial-author">
                  <strong>— {testimonial.author}</strong>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
